import React from "react";
import styled from "styled-components";
import { Gavel, Description, Article } from "@mui/icons-material";

const PageContainer = styled.div`
  background-color: var(--color-bg);
  min-height: 100vh;
  padding: 120px 24px;
`;

const ContentWrapper = styled.div`
  max-width: 900px;
  margin: 0 auto;
`;

const HeaderSection = styled.div`
  text-align: center;
  margin-bottom: 80px;
`;

const PageTitle = styled.h1`
  font-family: var(--font-serif);
  font-size: clamp(3rem, 6vw, 4rem);
  margin-bottom: 24px;
  color: var(--color-text);
`;

const PageSubtitle = styled.p`
  font-size: 1.25rem;
  color: var(--color-text-light);
  max-width: 600px;
  margin: 0 auto;
`;

const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 32px;
  margin-bottom: 48px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const InfoBox = styled.div`
  background: white;
  border: 1px solid rgba(0,0,0,0.1);
  border-radius: 12px;
  padding: 32px;
`;

const IconTitle = styled.h3`
  font-family: var(--font-serif);
  font-size: 1.5rem;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  color: var(--color-primary-blue);
`;

const Text = styled.p`
  color: var(--color-text-light);
  line-height: 1.7;
`;

const IframeContainer = styled.div`
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0,0,0,0.05);
  border: 1px solid rgba(0,0,0,0.1);
  background: white;
  height: 800px;
  
  @media (max-width: 768px) {
    height: 500px;
  }
`;

const StyledIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
`;

const Statuts = () => {
    return (
        <PageContainer>
            <ContentWrapper>
                <HeaderSection>
                    <PageTitle>Association Charter</PageTitle>
                    <PageSubtitle>
                        Official governing documents and regulations of SHALOM Association.
                    </PageSubtitle>
                </HeaderSection>

                <CardGrid>
                    <InfoBox>
                        <IconTitle><Gavel /> Legal Framework</IconTitle>
                        <Text>
                            Our association operates under Swiss law and adheres to all relevant regulations
                            governing student organizations at EPFL. The charter outlines our governance
                            structure, membership rules, and operational procedures.
                        </Text>
                    </InfoBox>

                    <InfoBox>
                        <IconTitle><Description /> Latest Version</IconTitle>
                        <Text>
                            Current charter, last updated and approved during the General Assembly of April 8th, 2025.
                            This document reflects our commitment to transparency and good governance.
                        </Text>
                    </InfoBox>
                </CardGrid>

                <IframeContainer>
                    <StyledIframe
                        src={process.env.PUBLIC_URL + "/statuts/SHALOM_statuts.pdf"}
                        title="SHALOM Association Charter"
                    />
                </IframeContainer>

                <div style={{ textAlign: 'center', marginTop: '60px', opacity: 0.7 }}>
                    <p><Article style={{ verticalAlign: 'middle', marginRight: '8px' }} /> Need clarification? <a href="/contact" style={{ textDecoration: 'underline', color: 'inherit' }}>Contact us</a>.</p>
                </div>

            </ContentWrapper>
        </PageContainer>
    );
};

export default Statuts;